import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getSearchResultList } from '../actions/api/search';
import { teamName, username } from '../selectors/session';
import {
  UserWatchList,
  UserWatchListMoreItem,
  UserWatchListProcessItem,
  UserWatchListRunItem
} from './index';
import { userWatchListItemsSelector } from './UserWatchListSelectors';

const MAX_NUMBER_OF_RUNS_TO_SHOW = 5;

export class UserWatchListContainer extends PureComponent {
  static displayName = 'UserWatchListContainer';

  static propTypes = {
    /**
     * Class to apply to the list items in the filter list
     */
    className: PropTypes.string,
    /**
     *  Action to list the runs that a user is involved in
     */
    getSearchResultList: PropTypes.func,
    /**
     * Click event to apply to the list items in the filter list
     */
    onClick: PropTypes.func,
    /**
     * Current team name.
     */
    teamName: PropTypes.string,
    /**
     * Current authed user's username.
     */
    username: PropTypes.string,
    /**
     *  List Item for watch list child nodes
     */
    userWatchListItems: PropTypes.arrayOf(
      PropTypes.shape({
        processDisplayName: PropTypes.string,
        processID: PropTypes.string,
        runs: PropTypes.objectOf(
          PropTypes.shape({
            displayName: PropTypes.string,
            percentComplete: PropTypes.number,
            runID: PropTypes.string
          })
        )
      })
    )
  };

  static contextTypes = {
    styleManager: PropTypes.object.isRequired
  };

  static HAS_COMPONENT_BEEN_LOADED = false;
  static CACHED_USER_WATCH_LIST;

  componentDidMount() {
    const { getSearchResultList, teamName, username } = this.props;
    if (!UserWatchListContainer.HAS_COMPONENT_BEEN_LOADED) {
      getSearchResultList({
        teamName,
        username,
        limit: 300,
        participatingUsers: username,
        searchID: 'userWatchList',
        status: 'running',
        sort: 'displayName',
        type: 'runs'
      });
    }
  }

  shouldComponentUpdate() {
    return !UserWatchListContainer.CACHED_USER_WATCH_LIST;
  }

  render() {
    const { className, onClick, userWatchListItems } = this.props;

    if (UserWatchListContainer.CACHED_USER_WATCH_LIST) {
      return UserWatchListContainer.CACHED_USER_WATCH_LIST;
    }

    if (userWatchListItems) {
      UserWatchListContainer.HAS_COMPONENT_BEEN_LOADED = true;
      UserWatchListContainer.CACHED_USER_WATCH_LIST = this.renderUserWatchList(
        userWatchListItems,
        className,
        onClick
      );
      return UserWatchListContainer.CACHED_USER_WATCH_LIST;
    }

    return null;
  }

  renderUserWatchList(userWatchListItems, className, onClick) {
    const userWatchListGroups = [];
    Object.values(userWatchListItems).forEach(process => {
      userWatchListGroups.push(
        this.renderWatchListForProcess(process, className, onClick)
      );
    });
    return <UserWatchList>{userWatchListGroups}</UserWatchList>;
  }

  renderWatchListForProcess(process, className, onClick) {
    const { processDisplayName, processID, runs: runsProp } = process;
    const numberOfRuns = Object.keys(runsProp).length;
    const numberOfRunsToShow = Math.min(
      numberOfRuns,
      MAX_NUMBER_OF_RUNS_TO_SHOW
    );
    const runs = Object.values(runsProp);

    return (
      <div key={`watchListProcess-${processID}`}>
        <UserWatchListProcessItem
          href={encodeURI(`/search?q=type:run ${processDisplayName}`)}
          {...{ className, onClick, processDisplayName }}
        />
        {runs
          .slice(0, numberOfRunsToShow)
          .map(({ displayName, percentComplete, runID }, i) => (
            <UserWatchListRunItem
              href={`/pushbots/${runID}`}
              key={`watchListRun-${runID}`}
              margin={i === numberOfRuns - 1}
              percentComplete={Math.floor(percentComplete * 100)}
              runDisplayName={displayName}
              {...{ className, onClick }}
            />
          ))}
        {numberOfRuns > MAX_NUMBER_OF_RUNS_TO_SHOW && (
          <UserWatchListMoreItem
            href={encodeURI(`/search?q=type:run ${processID}`)}
            {...{ className, onClick }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  teamName: teamName(state),
  username: username(state),
  userWatchListItems: userWatchListItemsSelector(state)
});

const mapDispatchToProps = {
  getSearchResultList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserWatchListContainer);



// WEBPACK FOOTER //
// ./js/UserWatchList/UserWatchListContainer.js